import { useCallback, useEffect, useState, RefObject } from "react"
import { useEmblaCarousel } from "embla-carousel/react"

interface SwipableControls<T = HTMLDivElement> {
  menuRef: RefObject<T>
  valuesRef: RefObject<T>
  currentIndex: number
  onTouch: (newIndex: number) => void
  reTrigger: () => void
}

function useSwipableContent<T>(): SwipableControls<T> {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [menuRef, menuApi] = useEmblaCarousel({
    containScroll: "keepSnaps",
    align: "start",
  })
  const [valuesRef, valuesApi] = useEmblaCarousel()

  const onTouch = useCallback(
    index => {
      if (valuesApi && menuApi?.clickAllowed()) {
        valuesApi.scrollTo(index)
      }
    },
    [menuApi, valuesApi]
  )

  const reTrigger = useCallback(() => {
    if (valuesApi && menuApi?.clickAllowed()) {
      menuApi.reInit()
      valuesApi.scrollTo(0)
    }
  }, [menuApi, valuesApi])

  const onSelect = useCallback(() => {
    if (valuesApi && menuApi) {
      setCurrentIndex(valuesApi.selectedScrollSnap())
      menuApi.scrollTo(valuesApi.selectedScrollSnap())
    }
  }, [valuesApi, menuApi, setCurrentIndex])

  useEffect(() => {
    if (valuesApi) {
      onSelect()
      valuesApi.on("select", onSelect)
    }
  }, [valuesApi, onSelect])

  return { menuRef, valuesRef, currentIndex, onTouch, reTrigger }
}

export default useSwipableContent
